import { createAsyncThunk } from "@reduxjs/toolkit";
import { APIS } from "../../app/utils/constants/apiConstant";
import { protectedApi } from "../../app/utils/common/protectedApi";

export const getTeamOnLeaveAPI = createAsyncThunk(
  "dashboard/getTeamOnLeaveAPI",
  async ({ date } = {}, { rejectWithValue }) => {
    try {
      const dateParam =
        date && /^\d{4}-\d{2}-\d{2}$/.test(String(date))
          ? String(date)
          : new Date().toISOString().slice(0, 10);
      const response = await protectedApi({
        url: `${APIS.LEAVE_TEAM_ON_LEAVE}?date=${encodeURIComponent(dateParam)}`,
        method: "GET",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.error ?? error);
    }
  }
);
